import { FactoryProvider, InjectionToken } from '@angular/core';

const WINDOW = new InjectionToken<Window>('window');

const windowProvider: FactoryProvider = {
    provide: WINDOW,
    useFactory: () => window,
};

const WINDOW_PROVIDERS = [windowProvider];

export { WINDOW, WINDOW_PROVIDERS };
